import appConfig from "../environment/config";

const awsmobile = {
    "aws_project_region": appConfig.awsProjectRegion, 
    "aws_cognito_identity_pool_id": appConfig.awsCognitoIdentityPoolId,
    "aws_cognito_region": appConfig.awsCognitoRegion, 
    "aws_user_pools_id": appConfig.awsUserPoolsId,
    "aws_user_pools_web_client_id": appConfig.awsUserPoolsWebClientId,
    "oauth": {
        "domain": appConfig.awsCognitoDomain, 
        "scope": [
            "phone",
            "email",
            "openid",
            "profile",
            "aws.cognito.signin.user.admin"
        ],
        "redirectSignIn": `${window.location.origin}/`,
        "redirectSignOut": `${window.location.origin}/`,
        "SignOutURI": `${window.location.origin}/`,
        "responseType": "code"
    },
    "aws_cognito_login_mechanism": [
        "EMAIL"
    ],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "authenticationFlowType": 'USER_PASSWORD_AUTH'
};

export default awsmobile;